var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"e-card e-rounding shadow-sm"},[_c('img',{staticClass:"d-block mx-auto",attrs:{"src":require("./../assets/money.jpg"),"width":"250"}}),_c('p'),_c('h1',{staticClass:"h3"},[_vm._v(_vm._s(_vm.$t('partner.title')))]),_vm._v(" "+_vm._s(_vm.$t('partner.body'))+" "),_c('p'),_vm._v(" "+_vm._s(_vm.$t('partner.action'))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }